var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-l-button',{attrs:{"disabled":_vm.isDisabled,"aria-label":"Botão submit","context":"secondary"},on:{"click":_vm.onSubmit}},[_vm._v("\n  "+_vm._s(_vm.updateLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }